import styled, { css, keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

import { palette, breakpoints, flexColumn } from '../../constants/styles';
import Section from '../landing/Section';
import { HEADER_HEIGHT } from '../GoalsFlow/styles';

export const StyledBankSavingModalContent = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledBlueSpan = styled.span`
  color: #08aeea;
  display: inline;
`;

export const StyledGreenSpan = styled.span`
  color: ${palette.secondaryColor};
  display: inline;
`;

export const StyledAchieveRetirementSection = styled.div`
  ${flexColumn}
  justify-content: center;
  align-items: center;
`;

export const StyledThumb = styled.img`
  border-color: ${palette.interestGray};
  cursor: pointer;
  border-style: solid;
  background-color: white;
  border-width: 4px 3px 4px 3px;
  margin-top: -54%;
  position: absolute;
  z-index: 10;
  border-radius: 8px;
  height: 100%;
  width: 97%;
  display: none;
  ${({ displayThumb }) => displayThumb && css`
    display: block;
  `}
`;

export const StyledBold = styled.b`
  color: #022759;
`;

export const StyledSendEmailButton = css`
cursor: pointer;
width: 100px;
height: 35px;
margin-top: 5px;

${breakpoints.mobileLandscape} {
  margin-bottom: 10px;
}

`;

export const StyledSecondaryValuePropCTA = css`
height: 35px;
color: ${palette.primaryColor};
background-color: white;
box-shadow: none;
border: 1px solid ${palette.primaryColor};
font-weight: 500;
width: 150px;

&:hover {
  background-color: white;
}  
`;

export const StyledTeamImage = styled.img`
max-width: 100%;
height: auto;
align-self: center;
margin: 10px 0px 30px 0px;

${breakpoints.mobileLandscape} {
  max-width: 60%;
}

${breakpoints.tabletLandscape} {
  max-width: 50%;
}

${breakpoints.desktop} {
  max-width: 450px;
}
`;

export const StyledCustomDivision = styled.hr`
display: block;
width: 100%;
height: 0px;
margin-top: 20px;
border-top: 1px solid ${palette.primaryColor}2b;
border-bottom: none;
`;


export const StyledResultSubSection = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const CompareImage = styled.img`
max-width: 100%;
height: auto;
align-self: center;
margin: 10px 0px 0px 0px;

${breakpoints.mobileLandscape} {
  max-width: 60%;
}

${breakpoints.tabletLandscape} {
  max-width: 50%;
}

${breakpoints.desktop} {
  max-width: 450px;
}
`;

export const OopsStartOverLink = styled(Link)`
  text-decoration: none;
`;

export const StyledSummary = styled.div`
`;

export const StyledUnderline = styled.u`
  text-decoration: none;
  border-bottom: 1.5px solid ${palette.secondaryColor};
`;

export const StyledCongratsTitle = css`
  margin-top: 20px;
  margin-bottom: 15px;
  align-self: center;
`;

export const StyledResultsError = styled.div`
  margin-top: ${(HEADER_HEIGHT)}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  width: 90%;
  height: fit-content;
  padding-bottom: 80vh;

  border-radius: 0px 0px 8px 8px;

  ${breakpoints.mobileLandscape} {
    padding: 0px 20px;
  }

  ${breakpoints.tablet} {
    width: 70%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
  }
`;

export const StyledResultsErrorContainer = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  ${breakpoints.mobileLandscape} {
    background-color: #f1f1f1;
  }
`;

export const StyledFinancialVehicle = styled.li`
  cursor: pointer;
  list-style-type: none;
  display: flex;
  flex-direction column;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(165,165,165,0.5);
  border-radius: 8px;
  width: 46%;
  height: 150px;
  text-align: center;

  ${breakpoints.tablet} {
    width: 30%;
    height: 165px;
    margin-bottom: -5px;
  }

`;

export const StyledFinancialVehiclesList = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding-left: 0px;
  flex-wrap: wrap;

  ${StyledFinancialVehicle}:nth-child(3):last-child {
      margin-top: 10px;
      padding-top: 10px;
  }

  ${breakpoints.tablet} {
    margin-bottom: 20px;

    ${StyledFinancialVehicle}:nth-child(3):last-child {
      padding-top: 0px;
      margin-top: 0px;
    }
  }
`;

export const FinalPunchStatementContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

export const FinalPunchStatement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid;
  border-width: 1px;
  border-color: black;
  border-radius: 20px;
  padding: 20px 0;
  width: 100%;

  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 20px 0px;
  background-color: rgba(67,206,162,0.2);
  border-color: rgba(67,206,162,0.2);
  border-radius: 12px;
  border-width: 1px;
  border-style: none;
`;


export const StyledResultTitle = css`
  margin-top: 0px;
  margin-bottom: 0px;

  ${({ retirement }) => retirement && css`
    align-self: center;
    margin-bottom: 10px;
  `}
`;

// Exepción de homogenización por & Before
export const StyledSteps = styled.ol`
  padding-inline-start: 10px;
  list-style: none;
  counter-reset: my-awesome-counter;
  & > li {
    & :before {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      content: counter(my-awesome-counter);
      color: #022759;
      width: 10%;
      font-size: 2em;
      font-weight: 500;
      align-self: flex-start;
    }
  }
`;

export const StyledCost = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${palette.sweetGray};
  width: 90%;

  height: 100%;

  padding: 20px 20px;

  ${breakpoints.tablet} {
    width: 70%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
  }
`;

export const StyledResultRetirementTitle = css`
  margin-top: 20px;
  align-self: center;
  margin-bottom: 10px;
`;

export const StyledResultDebtTitle = css`
  margin-top: 20px;
  align-self: center;
  margin-bottom: 10px;
  text-align: center;
`;

export const StyledResultSecondTitles = css`
  margin-top: 20px;
  margin-bottom: 0px;
`;

export const StyledDivision = styled.hr`
display: block;
width: 90vw;
height: 0px;
margin-top: 30px;
border-top: 1px solid ${palette.primaryColor}2b;
border-bottom: none;

${breakpoints.tablet} {
  display: none;
}
`;

export const StyledTabWrapper = styled.div`
  display: none;
  border: 1px solid #43CEA2;
  margin-top: -1px;
  z-index: 20;
  width: 100%;
  border-radius: 8px 8px 8px 8px;
  margin-bottom: 20px;
  padding-top: 20px;

  ${({ open }) => open && css`
    display: block;
  `}

  ${({ negative }) => negative && css`
    border: 1px solid #FF8000;
  `}
`;

export const fadein = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const StyledAccordionItem = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const StyledAccordionItemTitleContainer = styled.div`
  cursor: pointer;
  border: solid;
  padding: 8px 10px 0px 10px;
  border-color: rgba(2, 39, 89, 0.2);
  border-width: 0.5px;
  border-bottom: none;
  border-radius: 8px 8px 0px 0px;

  ${({ disclaimer }) => disclaimer && css`
    padding: 0px 10px 0px 10px;
  `}

  ${({ color }) => color && css`
    border-color: ${color};
  `}

`;

export const StyledDisclaimerBullets = styled.li`
  margin-bottom: 10px;
  line-height: 20px;
  list-style-type: none;
`;

export const StyledResultsDescription = styled.ul`
  color: black;
  padding-left: 0px;
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const StyledFeedbackButton = css`
  cursor: pointer;
  box-shadow: none;
  width: 130px;
  border: 1px solid #FF8000;
  background-color: white;
  height: 80px;

  color: black;
  border-radius: 8px 8px 0px 0px;

  ${breakpoints.mobileLandscape} {
    width: 145px;
    height: 120px;
  }

  ${breakpoints.tablet} {
    width: 160px;
    height: 120px;
  }

  ${breakpoints.desktop} {
    width: 215px;
    height: 80px;
  }

  ${({ open }) => open && css`
    border-bottom: 2px solid white;
    z-index: 200;
  `}

  ${({ positive }) => positive && css`
    border: 1px solid #43CEA2;

    ${({ open }) => open && css`
      border-bottom: 2px solid white;
      z-index: 200;
    `}
  `}
`;

export const LoadingImage = styled.img`
  object-fit: cover;
  width: 250px;
  object-position: 50% 0;
  height: 350px;
`;

export const WrapperContent = styled.div`
  padding: 0px 20px 20px 20px;
`;

export const FirstSection = styled(Section)`
  margin-top: 50px;
  height: fit-content;
  justify-content: center;
  background-color: white;

  ${breakpoints.tablet} {
    width: 60%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const StyledResultTable = styled.tbody`
  & > tr > th {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  & > tr > * {
    border-bottom: 1px solid #ddd;
    padding: 5px;
    text-align: center;

    // Labels
    &:nth-child(1) {
      width: 20%;
      text-align: left;
    }
    // Bank
    &:nth-child(2) {
      width: 40%;
    }
    // Best option
    &:nth-child(3) {
      width: 40%;
      background-color: rgba(38, 221, 170, 0.1);
    }
  }
`;

export const StyledResultTableSavings = styled.tbody`
  & > tr > th {
    padding: 0px;
    border-bottom: none;
  }
  & > tr > * {
    border-bottom: 1px solid #ddd;
    padding: 5px;
    text-align: center;

    // Colors
    &:nth-child(1) {
      width: 20px;
      text-align: left;
    }
    // Labels
    &:nth-child(2) {
      width: 50%;
      text-align: left;
    }
    // Money
    &:nth-child(3) {
      width: 30%;
      border-left: 1px solid #ddd;
    }
    // Percentage
    &:nth-child(4) {
      width: 20%;
      border-left: 1px solid #ddd;
    }
  }
`;


export const WrapperContentDebt = styled.div`
  width: 100%;
`;

export const StyledFeedbackSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  margin-top: 10px;
`;

export const StyledFaceIcon = css`
  ${breakpoints.desktop} {
    margin-right: 10px;
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${palette.sweetGray};
  padding-top: 20px;
  padding-bottom: 30px;
  width: 100%;

  ${breakpoints.tablet} {
    width: 70%;
    max-width: 500px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const StyledInput = styled.input`
  border-top: none;
  border-right: none;
  border-left: none;
  width: 15em;
  text-align: left;
  outline: none;
  border-bottom: 2px dashed #022759;
  margin-right: 10px;
  border-radius: 2px;
  padding-left: 10px;
`;

export const StyledVideoWrapper = styled.div`
  position: relative;
  padding-top: 54.5% /* Player ratio: 100 / (1280 / 720) */
`;

export const StyledShortCaption = css`
  ${breakpoints.tablet} {
    display: none;
  }
`;

export const StyledLongCaption = css`
  display: none;

  ${breakpoints.tablet} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  ${breakpoints.desktop} {
    flex-direction: row;
  }
`;


export const StyledAccordionItemBodyContainer = styled.div`
  border: solid;
  padding: 0px 10px 8px 10px;
  border-color: rgba(2, 39, 89, 0.2);
  border-width: 0.5px;
  margin-top: 0px;
  border-top: none;
  border-radius: 0px 0px 8px 8px;

  ${({ color }) => color && css`
    border-color: ${color};
  `}
`;

export const StyledAccordionBody = {
  paddingTop: '20px',
  animationName: fadein,
  animationDuration: '0.35s',
  animationTimingFunction: 'ease-in-out',
};

export const NegativeWrapperText = styled.p`
  margin-bottom: 20px !important;
  margin-top: 0px !important;
  line-height: 20px;

  ${({ lessMarginBottom }) => lessMarginBottom && css`
    margin-bottom: 10px !important;
  `}

`;

export const StyledResults = styled.div`
  position: relative;
  background-color: white;

  ${({ fullscreen }) => fullscreen && css`
    height: 100vh;
  `}
`;


export const NegativeWrapperListItem = styled.p`
  margin-bottom: 10px !important;
  margin-top: 0px !important;
  line-height: 20px;
`;

export const StyledDashedImage = styled.img`
  height: 90px;
  position: absolute;
  z-index: 1;
  width: 1px;
  margin-left: 9.75px;
  margin-top: -86px;
`;

export const EmailForm = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;

  ${breakpoints.mobileLandscape} {
    justify-content: flex-start;
  }
`;

export const StyledLink = styled.a`
  cursor: pointer;
  color: blue;
  margin-left: 0.3rem;
`;

export const ModalTitle = css`
  margin-right: 30px;
`;

export const MyCertifiedModal = css`
  max-height: none;
  margin: 0;
  border-radius: 0px;
  width: 100vw;
  min-height: 100vh;
  
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoints.tablet} {
    height: auto;
    width: 90vw;
    margin-top: 5vh;
    margin-bottom: 5vh;
  }
`;

export const StyleGoalModal = css`
  height: 230px;
  border-radius: 0px;
  max-height: none;
  margin: 0;
  border-radius: 0px;
  width: 90vw;
  margin-top: 5vh;
  margin-bottom: 5vh;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;
  margin-top: 30vh;

  ${breakpoints.tabletLandscape} {
    max-width: 300px;
  }
`;

export const WhiteLogo = styled.img.attrs(({ src }) => src)`
  width: 100px;
  margin-right: 10px;
  justify-self: flex-start;
`;

export const CertifiedModalContent = styled.div`
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  min-width: 90%;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ChangeOfPlans = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const StyledStartOverButton = css`
  cursor: pointer;
  width: fit-content;
  height: 40px;
  padding: 0px 20px;
  background-color: #022759;

  ${({ error }) => error && css`
    align-self: center;
  `}

`;